// extracted by mini-css-extract-plugin
export default {"header":"Header_header__SXMHR","appTitle":"Header_appTitle__3mMXe","darkMode":"Header_darkMode__FlPtu"};